
export namespace RtkQueryHelper {

    export const checkResultIsFulfilled = ( result : unknown) => {
        return result instanceof Object && Object(result)?.status === "fulfilled"
    }

}